// // Use $ instead of jQuery without replacing global $
(function ($) {


  if($('.col-hover-block.bg-gray').length > 0) {
    /* Load more click count. */
    var item_show = 6,
        length = '';

    /* Function to hide and show element on Load */
    function load_OnReady() {
      $('.col-hover-block.bg-gray .box-wrap').find('.card').each(function () {
        length = $(this).parents('.col-hover-block.bg-gray .box-wrap').find('.card').length;
        // console.log(length);
        var index = $(this).index();
        if (index >= item_show) {
          $(this).css('display', 'none').removeClass('active-filter');
        }
        else {
          $(this).css('display', 'block').addClass('active-filter');
        }
        if (length <= item_show) {
          $(this).parents('.col-hover-block.bg-gray').find('.load-more').css('display', 'none');
        } else {
          $(this).parents('.col-hover-block.bg-gray').find('.load-more').css('display', 'inline-block');
        }
      });
    }

    /* Function to show element on Load more click */
    function loadMore() {
      var $i = 0;
      $('.col-hover-block.bg-gray .box-wrap .card').each(function () {
        var $dataDisplay = $(this).css('display');
        if ($dataDisplay == 'block') {
          $i++;
        }
      });
      if ($i < length) {
        for (var $j = $i; $j < ($i + item_show); $j++) {
          $('.col-hover-block.bg-gray .box-wrap .card').eq($j).css({'display': 'block'});
          if (($i + item_show) >= length) {
            $('.col-hover-block.bg-gray .load-more').css({'display': 'none'});
          }
        }
      } else {
        $('.col-hover-block.bg-gray .load-more').css({'display': 'none'});
      }
    }

    var f2 = 0, f3 = 0;
    $(window).ready(function () {
      var winWidth = $(window).width();
      if (winWidth < 768) {
        if (f2 == 0) {
          load_OnReady();
          f2 = 1;
        }
      }
    });

    $(window).resize(function () {
      var winWidth = $(window).width();
      if (winWidth < 768) {
        if (f3 == 0) {
          load_OnReady();
          f3 = 1;
        }
      }
      else {
        $('.col-hover-block.bg-gray .box-wrap .card').removeAttr('style');
      }
    });

    $(document).on('click', '.col-hover-block.bg-gray .load-more', function () {
      loadMore();
    });
  }



  if($('.col-hover-block.bg-light-gray').length > 0) {
    /* Load more click count. */
    var item_show1 = 6,
        length1 = '';

    /* Function to hide and show element on Load */
    function load_OnReady1() {
      $('.col-hover-block.bg-light-gray .box-wrap').find('.card').each(function () {
        length1 = $(this).parents('.col-hover-block.bg-light-gray .box-wrap').find('.card').length;
        // console.log(length);
        var index1 = $(this).index();
        if (index1 >= item_show1) {
          $(this).css('display', 'none').removeClass('active-filter');
        }
        else {
          $(this).css('display', 'block').addClass('active-filter');
        }
        if (length1 <= item_show1) {
          $(this).parents('.col-hover-block.bg-light-gray').find('.load-more').css('display', 'none');
        } else {
          $(this).parents('.col-hover-block.bg-light-gray').find('.load-more').css('display', 'inline-block');
        }
      });
    }

    /* Function to show element on Load more click */
    function loadMore1() {
      var $k = 0;
      $('.col-hover-block.bg-light-gray .box-wrap .card').each(function () {
        var $dataDisplay1 = $(this).css('display');
        if ($dataDisplay1 == 'block') {
          $k++;
        }
      });
      if ($k < length1) {
        for (var $j = $k; $j < ($k + item_show1); $j++) {
          $('.col-hover-block.bg-light-gray .box-wrap .card').eq($j).css({'display': 'block'});
          if (($k + item_show1) >= length1) {
            $('.col-hover-block.bg-light-gray .load-more').css({'display': 'none'});
          }
        }
      } else {
        $('.col-hover-block.bg-light-gray .load-more').css({'display': 'none'});
      }
    }

    var f4 = 0, f5 = 0;
    $(window).ready(function () {
      var winWidth = $(window).width();
      if (winWidth < 768) {
        if (f4 == 0) {
          load_OnReady1();
          f4 = 1;
        }
      }
    });

    $(window).resize(function () {
      var winWidth = $(window).width();
      if (winWidth < 768) {
        if (f5 == 0) {
          load_OnReady1();
          f5 = 1;
        }
      }
      else {
        $('.col-hover-block.bg-light-gray .box-wrap .card').removeAttr('style');
      }
    });

    $(document).on('click', '.col-hover-block.bg-light-gray .load-more', function () {
      loadMore1();
    });
  }

  $(document).ready(function () {
    var col_hover_block = $('.col-hover-block .box-wrap .block .img-box img');
    objectFitImages(col_hover_block);


    limit_lines('.col-hover-block .box-wrap .block .hover-box p',3);


    function makeTall1() {
      $(this).addClass('active');
    }

    function makeShort1() {
      $(this).removeClass('active');
    }

    $(".col-hover-block .box-wrap .block").hoverIntent(makeTall1, makeShort1);
  });

})(jQuery);

